import { render, staticRenderFns } from "./CatalogEntryPopup.vue?vue&type=template&id=652f6762"
import script from "./CatalogEntryPopup.vue?vue&type=script&lang=ts"
export * from "./CatalogEntryPopup.vue?vue&type=script&lang=ts"
import style0 from "./CatalogEntryPopup.vue?vue&type=style&index=0&id=652f6762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QIcon,QBtn,QCardActions,QSpinner,QSlider});qInstall(component, 'directives', {ClosePopup});
